/**
 * 
 * @returns 
 */
function isAndroid() {
    const ua = window.navigator.userAgent.toLowerCase();

    //
    return !!ua.match(/Android/i);
};

function isIos() {
    const ua = window.navigator.userAgent.toLowerCase();

    //
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
};

/**
 * 
 * @returns 
 */
function ifZiubaoAndroidWebView()
{
    if (window.WeChatTongDaPay && window.WeChatTongDaPay.fetchAppName && window.WeChatTongDaPay.fetchAppName() == 'ziubao')
    {
        return true;
    }

    //
    return false;
}

async function ifZiubaoIosWebView() {
    if (window.ifVarZiubaoIosWebView) {
        return window.ifVarZiubaoIosWebView;
    }


    //
    window.iosGtzn = {
        fetchAppNameCb: appType => {
            if (appType == 'ziubao') {
                window.ifVarZiubaoIosWebView = true;
            }
            else {
                window.ifVarZiubaoIosWebView = false;
            }
        }
    }

    //
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fetchAppName) {
        // 获取app名称
        window.webkit.messageHandlers.fetchAppName.postMessage({

        });

        //
        let count = 0;
        while (count++ < 20) {
            if (window.ifVarZiubaoIosWebView) {
                return window.ifVarZiubaoIosWebView;
            }

            await new Promise(resolve => {
                setTimeout(() => {
                    resolve();
                }, 50);
            })
        }

        return false;
    }

    //
    return false;
}

/**
 * 
 * @returns 
 */
function ifYszsAndroidWebView()
{
    if (window.WeChatTongDaPay && window.WeChatTongDaPay.fetchAppName && window.WeChatTongDaPay.fetchAppName() == 'yszs') {
        return true;
    }

    //
    return false;
}

async function ifYszsIosWebView() {
    if (window.ifVarYszsIosWebView) {
        return window.ifVarYszsIosWebView;
    }


    //
    window.iosGtzn = {
        fetchAppNameCb: appType => {
            if (appType == 'yszs') {
                window.ifVarYszsIosWebView = true;
            }
            else
            {
                window.ifVarYszsIosWebView = false;
            }
        }
    }

    //
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fetchAppName) {
        // 获取app名称
        window.webkit.messageHandlers.fetchAppName.postMessage({

        });

        //
        let count = 0;
        while (count++ < 20) {
            if (window.ifVarYszsIosWebView) {
                return window.ifVarYszsIosWebView;
            }

            await new Promise(resolve => {
                setTimeout(() => {
                    resolve();
                }, 50);
            })
        }

        return false;
    }

    //
    return false;
}

function ifWechat() {
    const matched = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i);

    //
    if (!matched) {
        return false;
    }

    //
    return matched.toString() === "micromessenger";
}

/**
 * 
 * @returns 
 */
function fetchZiubaoAndroidWebViewVersionCode() {
    if (window.WeChatTongDaPay && window.WeChatTongDaPay.fetchAppVersionCode) {
        return window.WeChatTongDaPay.fetchAppVersionCode();
    }

    //
    return null;
}


/**
 * 
 * @returns 
 */
async function fetchZiubaoIosWebViewVersion() {
    if (window.ziubaoIosWebViewVersion) {
        return window.ziubaoIosWebViewVersion;
    }

    //
    window.iosGtzn = {
        fetchAppVersionCb: version => {
            window.ziubaoIosWebViewVersion = version;
        }
    }

    //
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fetchAppVersion) {
        // 获取app名称
        window.webkit.messageHandlers.fetchAppVersion.postMessage({

        });

        //
        let count = 0;
        while (count++ < 20) {
            if (window.ziubaoIosWebViewVersion) {
                return window.ziubaoIosWebViewVersion;
            }

            await new Promise(resolve => {
                setTimeout(() => {
                    resolve();
                }, 50);
            })
        }

        return null;
    }

    //
    return null;
}

export {
    isAndroid,
    isIos,
    ifZiubaoAndroidWebView,
    ifYszsAndroidWebView,
    ifZiubaoIosWebView,
    fetchZiubaoIosWebViewVersion,
    fetchZiubaoAndroidWebViewVersionCode,
    ifYszsIosWebView,
    ifWechat,
}